import React, { useCallback } from 'react';
import styles from './index.module.scss';
import { Controller, useFieldArray } from 'react-hook-form';
import { ActionSelect } from '../ActionSelect';
import { QuestControlProps } from '../..';
import { IconClose } from '@/assets/quest';
import cx from 'clsx';
import { QuestType } from '../../type';
import { useQuestEstimate } from '../PayInfoCard/hooks';
import { checkActionsEmpty } from '../../utils';

type TaskSelectProps = {
  control: QuestControlProps;
  quest?: QuestType;
};

const MAX_ACTION = 10;

export const ActionFields = ({ control, quest }: TaskSelectProps) => {
  const { data: questEstimate } = useQuestEstimate({
    // 查询单价
    quest,
    enabled: !checkActionsEmpty(quest?.actions),
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: `actions`,
  });

  const handleClickAddAction = useCallback(
    (disabled: boolean) => {
      if (disabled) {
        return;
      }
      append({ type: undefined, data: undefined });
    },
    [append],
  );

  return (
    <div className={styles.container}>
      {fields.map((field, i) => (
        <div className={styles.action} key={field.id}>
          <div className={styles.actionTitle}>action {i + 1}</div>
          <div className={styles.actionContent}>
            <div className={styles.actionSelect}>
              <Controller
                key={field.id}
                name={`actions.${i}`}
                control={control}
                render={({ field: f }) => {
                  const actionUnitFee = questEstimate?.actions?.find(
                    i => i.type === f.value?.type,
                  )?.unit_fee;
                  return (
                    <ActionSelect
                      value={f.value}
                      onChange={f.onChange}
                      actionUnitFee={actionUnitFee}
                    />
                  );
                }}
              />
            </div>
            <div className={styles.closeIconContainer}>
              {fields.length > 1 && (
                <IconClose className={styles.closeIcon} onClick={() => remove(i)} />
              )}
            </div>
          </div>
        </div>
      ))}
      <div
        className={cx(styles.addBtn, fields.length >= MAX_ACTION && styles.disabled)}
        onClick={() => handleClickAddAction(fields.length >= MAX_ACTION)}>
        + Add action
      </div>
    </div>
  );
};
